import { initializeApp } from 'firebase/app'
import { Firestore, getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyCJQq_d7oUs4hZHYM1YC9jQ7IKni1iGTxk',
  authDomain: 'bmed-a08c3.firebaseapp.com',
  projectId: 'bmed-a08c3',
  storageBucket: 'bmed-a08c3.firebasestorage.app',
  messagingSenderId: '969063715284',
  appId: '1:969063715284:web:f04b79473c0e28c610c641',
  measurementId: 'G-CXJKVT13BT',
}

const app = initializeApp(firebaseConfig)

/**
 * Keep a copy of the database on this device (IndexedDB). Reloading the app then
 * resumes from the cache instead of re-downloading every record, which keeps the
 * project well inside its daily Firestore read quota. Falls back to the default
 * in-memory cache if the browser blocks IndexedDB (e.g. some private windows).
 */
const createDb = (): Firestore => {
  try {
    return initializeFirestore(app, { localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }) })
  } catch (error) {
    console.warn('Offline cache unavailable — using in-memory cache.', error)
    return getFirestore(app)
  }
}

export const db = createDb()

/** True when Firestore rejected a request because the project's daily quota is used up. */
export const isQuotaError = (error: unknown) => {
  const e = error as { code?: string; message?: string } | undefined
  return e?.code === 'resource-exhausted' || /quota/i.test(e?.message ?? '')
}

export const QUOTA_MESSAGE =
  'The database has reached its daily usage limit (Firebase free "Spark" plan), so nothing can be saved right now. ' +
  'Your entry was not saved — try again after the quota resets (midnight US Pacific time, about 10:00 Lusaka time), ' +
  'or ask the system owner to upgrade the Firebase project "bmed-a08c3" to the pay-as-you-go "Blaze" plan.'

/**
 * localStorage is only a convenience cache. Browsers cap it at ~5 MB; when a write
 * would exceed that, drop the oversized cache entry instead of crashing the app.
 */
export const safeLocalSet = (key: string, value: string) => {
  try {
    localStorage.setItem(key, value)
  } catch {
    try {
      localStorage.removeItem(key)
    } catch {
      /* storage unavailable — nothing to do */
    }
  }
}
